import { useEffect, useState } from "react";
import _ from "lodash";
import { DBNEntityAttributesComponents } from "../components/entity-attributes..components";
import { deepCopy } from "../../../../../../../common/services/common.service";
import Popup from "../../../../../../../common/components/popup";
import OpenNetworkCategoriesList from "../../components/dbn-global-categories-list";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { useSelector } from "react-redux";
import { selectOpennetworkCategoriesListItems } from "../../../../../../../redux/dbn-cloud/opennetwork-categories/selector";
import { opennetworkCategories } from "../../../../../../../redux/dbn-cloud/opennetwork-categories/action";


let currentChange: any = {};
export const DBNEntityAttributesContainers = ({
  id,
  ownerTypeId,
  category,
  categoryIndex,
  dbnEntityAttributes,
  setDbnEntityAttributes,
  setProductOpenNetworkCategoriesValueMappings,
  selectedCategories
}:any) => {
  const dispatch = useAppDispatch();
  const [openFile, setOpenFile] = useState<any>([]);
  const [productImageIndex, setProductImageIndex] = useState<any>([]);
  const [openConfirmationFile, setOpenConfirmationFile] = useState(false);
  const [showDBNCategoriesPopup, setShowDBNCategoriesPopup] = useState<any>(false);
  const [dbnCategoriesList, setDbnCategoriesList] = useState<any>([]);
  const categoriesListData = useSelector(selectOpennetworkCategoriesListItems)

  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'EntityAttributeName',
        headerName: 'Name',
        sortable: true,
        filter: true,
        
      },
      {
        field: 'EntityAttributeTypeId',
        headerName: 'Type',
        sortable: true,
        filter: true,
        
      },            
      {field: '', headerName: 'Values', sortable: false, filter: false, cellRenderer: 'AttributeValuesRenderer'}

    ]);
  }
  
  // const [selectedCategories, setSelectedCategories] = useState<any>([]);

  // useEffect(()=>{
  //   const categories: any = _.filter(dbnCategoriesLists?.result?.items, item =>
  //     item.OpenNetworkDomainId === selectedProduct?.OpenNetwork?.OpenNetworkDomainId && _.includes(selectedProduct?.OpenNetwork?.OpenNetworkCategoryIds, item.Id)
  //   );
  //   console.log('selectedCategories', categories)
  // setSelectedCategories(categories);
  // console.log('categories?.EntityAttributeValueMappings', categories?.EntityAttributeValueMappings)
  // setProductOpenNetworkCategoriesValueMappings(categories?.EntityAttributeValueMappings)
  // },[openNetworkCategoriesOfProduct])
 
  const addNewRow = ({ selectedStatusArg }: any) => {
    const localSelectedStatus = deepCopy(selectedStatusArg);
    const newsLogistics = {
      Id: 0,
      OwnerTypeId: ownerTypeId,
      OwnerId: id,
      EntityAttributeName:'',
            "MappedOwnerTypeId": 0,
      "MappedOwnerId": 0,
      EntityAttributeId: 0,
      EntityAttributeValue: {
        MultiControlType: {
          ValueItem1: {},
          ValueItem2: {},
          ValueItem3: {},
          ValueItem4: {},
          ValueItem5: {},
        },
        SingleControlType: {},
      },
    };
    if (
      localSelectedStatus.length === 0 ||
      localSelectedStatus[localSelectedStatus?.length - 1]
        ?.EntityAttributeName !== '' ||
      localSelectedStatus[localSelectedStatus?.length - 1]
        ?.EntityAttributeId !== 0
    ) {
      localSelectedStatus?.push(newsLogistics);
    }

    return localSelectedStatus;
  };

  const setCombinationInfo = async () => {
    let localSelectedStatus = deepCopy(dbnEntityAttributes);
    localSelectedStatus.splice(currentChange.idx, 1, {
      ...localSelectedStatus[currentChange.idx],
    });
    localSelectedStatus = addNewRow({ selectedStatusArg: localSelectedStatus });
    currentChange.field = 'EntityAttributeNameD1';
    setDbnEntityAttributes(localSelectedStatus);
  };

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(category?.EntityAttributeValueMappings); // deep copy of grn items
    console.log('EntityAttributeValueMappings items', items)
    let item = items[idx]; // deep copy of item to be edited
    item = { ...item, [field]: value }; // updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx };
    console.log('dbnEntityAttributes items', items)
    setDbnEntityAttributes(items);
  };

  const handleSingleControlTypeItemChange: any = ({ categoryIndex, value, field, idx }: any) => {
    console.log('productOpenNetworkCategoriesValueMappings', selectedCategories, categoryIndex)
    const items = deepCopy(selectedCategories[categoryIndex]?.EntityAttributeValueMappings);
    console.log('productOpenNetworkCategoriesValueMappings items', items)
    console.log('New Value', value)
    console.log('value, field, idx', value, field, idx)
    // const items = deepCopy(dbnEntityAttributes); // deep copy of grn items
    let item = items[idx]?.EntityAttributeValue?.SingleControlType; // deep copy of item to be edited
    item = { ...item, [field]: value }; // updated the particular item
    console.log('updated item', item)
    items[idx].EntityAttributeValue.SingleControlType = item;
    currentChange = { value, field, idx };
    console.log('Changed items', items)
    // setOpenNetworkCategoriesOfProduct(items);
    setProductOpenNetworkCategoriesValueMappings(items)
    // console.log('dbnEntityAttributes items', items)
    // setDbnEntityAttributes(items);
  };

  // const changeImage = (idx: number, templateField: any, fileType: any) => {
  //   setOpenConfirmationFile(true);
  //   setProductImageIndex(idx);
  //   setOpenFile({
  //     currentFileSrc: dbnEntityAttributes[idx][templateField],
  //     folder: 'product',
  //     type: fileType,
  //   });
  // };

  // const handleConfirmationFile = () => {
  //   setOpenConfirmationFile(false);
  // };
  // const handleSubmit = (data: any) => {
  //   dbnEntityAttributes[productImageIndex].FileMappingUrl = data;
  //   const localSelectedMedia = addNewRow({
  //     selectedStatusArg: dbnEntityAttributes,
  //   });
  //   setDbnEntityAttributes(localSelectedMedia);
  // };
  // useEffect(() => {
  //   if(dbnEntityAttributes){
  //     const localSelectedStatus = addNewRow({
  //       selectedStatusArg: dbnEntityAttributes,
  //     });
  //     setDbnEntityAttributes(localSelectedStatus);
  //   }
    
  // }, [dbnEntityAttributes]);

  // useEffect(() => {
  //   if (currentChange.field === 'EntityAttributeName') {
  //     setCombinationInfo();
  //   }
  // }, [dbnEntityAttributes]);
  // const deleteEntityAttribute = async (Item: any, index: any) => {
  //   if (Item.Id === 0) {
  //     dbnEntityAttributes?.splice(index, 1);
  //   } else {
  //     // await deleteEntityAttributes(Item?.Id).then(() => {
  //     //   dbnEntityAttributes.splice(index, 1);
  //     // });
  //   }
  // };


  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Import DBN Attibutes</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Add Product Attribute Mapping',
      callback: () => handleAddAttribute(),
    }
  ];

  const handleAddAttribute = () => {
    setShowDBNCategoriesPopup(true)
  }

  const closeModal = () => {
    setShowDBNCategoriesPopup(false)
  }

  const handleSubmit = (data: any) => {
    console.log('Selected categories list:', data)
    updateSelectedCatgories(data);
    closeModal();    
  }

  const updateSelectedCatgories = async (data: any) => {
    console.log('dbn category',data)
    const localCategory = deepCopy(category)
    localCategory["EntityAttributes"] = data[0].EntityAttributeValueMappings
    console.log('update Category', localCategory)

    category.EntityAttributeValueMappings = data[0].EntityAttributeValueMappings
    
    // dispatch(tenantOpenNetworkCategories.resetAction({actionType:'update'})) 
    // await dispatch(tenantOpenNetworkCategories.update({
    //     url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/tenant-open-network-categories`,
    //     entity: 'tenantOpenNetworkCategories',
    //     jsonData: {
    //         Context:{},
    //         Records: localCategory
    //     }
    // }))
  }

  const listOpenNetworkCagtegories = () => {
    dispatch(opennetworkCategories.resetAction({actionType:'list'})) 
    dispatch(opennetworkCategories.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch`,
        entity: 'tenantOpenNetworkDomains',
        jsonData: {
          "PageNumber": 1,
          "PageSize": 100,
          "SortField": "Id",
          "SortOrder": "desc",
        }
    }))
  }


  const LoadOpenNetworkCategoriesList = () => {
    return (
      <Popup onClose={closeModal}>
            <OpenNetworkCategoriesList 
                openNetworkCategories={dbnCategoriesList}
                initiallySelectedCategories={[]}
                handleSubmit={handleSubmit}
                closeModal={closeModal}            
            />
          </Popup>
    )
  }

  useEffect(() => {
    setDbnCategoriesList(categoriesListData?.result?.items)
  }, [categoriesListData]);

  useEffect(() => {
    createColumnDefs();
    listOpenNetworkCagtegories();
  }, []);

  return (
    <>
{showDBNCategoriesPopup ? <LoadOpenNetworkCategoriesList /> : <></>}
{/* {
  <Table 
  key={''}
  columnData={''} 
  rowData={[]} 
  paginationData={''}
  onEdit={()=>{}} 
  onDelete={()=>{}} 
  handleClickAttributeValues={()=>{}}
  additionButtons={additionButtons}
  checkboxConfig={{
    allowMultiSelect: true,
    defaultSelectedIds: [],
    isDisabled: false,
    keyColumn: 'Id',
  }}
  headingName="Attributes" 
/>
} */}
        {
        // openNetworkCategoriesOfProduct && _.map(openNetworkCategoriesOfProduct, (category: any, index: any) => (                    
        _.map(category?.EntityAttributes, (entityAttribute: any, index: any) => (
            <DBNEntityAttributesComponents
              key={`opennetwork-entity-attributes-components-${entityAttribute?.EntityAttributeName}-${index}`}          
              entityAttribute={entityAttribute}
              handleFormItemChange={handleFormItemChange}
              handleSingleControlTypeItemChange={handleSingleControlTypeItemChange}
              entityAttributeIndex={index}
              categoryIndex={categoryIndex}
              // deleteEntityAttribute={deleteEntityAttribute}
              // changeImage={changeImage}
            />
            // <>{entityAttribute.EntityAttributeName}</>
          ))
        // ))
      }
    </>
  );
};
